import { buildApiActions } from '@/utils/vuex-api-utils';
import { verificationsApi } from '../../utils/diligence-service';
import _ from 'lodash';

export default {
  state: {
    businessVerification: null,
  },
  getters: {
    businessVerification: (state) => state.businessVerification,
    businessVerificationCodes: (state) => {
      return (
        state.businessVerification?.verificationStatus?.business_instant_id
          ?.metadata?.businessVerifications?.data?.riskIndicators?.codes || []
      );
    },
    userVerificationCodes: (state, getters, rootState, rootGetters) => {
      return (
        state.businessVerification?.verificationStatus?.business_instant_id
          ?.metadata?.userVerifications?.[rootGetters.userId]?.data
          ?.riskIndicators?.codes || []
      );
    },
  },
  ...buildApiActions({
    GET_VERIFICATION: {
      action: (ctx, payload) => ({
        requestFunc: async () => {
          return verificationsApi.verificationsControllerFindLatestVerificationsV2(
            String(payload.businessId),
            payload.entityId,
            payload.entityType,
            false,
          );
        },
      }),
      mutation: (state, { response }) => {
        state.businessVerification = Array.isArray(response)
          ? response[0]
          : undefined;
      },
    },
    POST_VERIFICATION: {
      action: (ctx, payload) => ({
        requestFunc: async () => {
          return verificationsApi.verificationsControllerRunVerification(
            payload.type,
            payload.entityId,
            payload.entityType,
            {
              businessId: payload.businessId.toString(),
            },
          );
        },
        async afterSuccess() {
          await Promise.allSettled([
            ctx.dispatch('api-GET_USER', {
              userId: ctx.rootGetters.user.id,
            }),
            ctx.dispatch('api-GET_USERS_FOR_BUSINESS', {
              userId: ctx.rootGetters.user.id,
            }),
          ]);
        },
      }),
      mutation: (state, { response }) => {
        if (response) {
          state.businessVerification = response;
        }
      },
    },
  }),
};
